import Bus from '@/assets/js/bus.js';
export default {
  props: {
    partyCode: [String, Number],
    partyInfo: Object
  },
  data() {
    return {
      receiverId: '',
      outputId: '',
      receiverParams: {
        pageNum: 1,
        pageSize: 20,
        living: true,
        offline: false,
        online: true,
        condition: ''
      },
      receiverList: [],
      scroll: {
        distance: 15,
        directive: '.pullStreamDrop .el-scrollbar__wrap',
        onScroll: this.getMoreReceiverList
      },
      loadingBtn: false,
      loading: false,
      noMore: false,
      nameCheck: false,
      nameInfo: {
        show: false
      },
      tipsInfo: {
        title: 'pushParticipantSource.switchLive',
        content: '',
        cancel: 'pushParticipantSource.cancel',
        save: 'pushParticipantSource.confirm',
        show: false
      }
    };
  },
  computed: {
    sendBtnColor() {
      let color = 'gray';
      if (this.receiverId) {
        color = 'green';
        if (this.receiverId == this.outputId) {
          color = 'red';
        }
      }
      return color;
    }
  },
  created() {
    this.nameCheck = this.partyInfo.status.showSlotText;
    this.outputId = this.partyInfo.status.pullStreamReceiverId;
    this.receiverId = this.outputId;
    this.getReceiverList();
    Bus.$on('endParty', val => {
      this.receiverId = '';
      this.outputId = '';
    });
    Bus.$on('stopPullStream', v => {
      this.outputId = '';
    });
  },
  methods: {
    getReceiverList(val) {
      if (val === false || this.loading) return;
      if (val === true) {
        this.receiverParams.pageNum = 1;
        this.receiverParams.condition = '';
      }
      this.loading = true;
      this.axios.post('/partyline-backend/receiver/v2/page', this.receiverParams).then(res => {
        this.loading = false;
        if (res.data.errorCode === '0x0') {
          const {
            cc
          } = res.data.result;
          if (cc.isLastPage) {
            this.noMore = true;
          } else {
            this.noMore = false;
          }
          if (this.receiverParams.pageNum == 1) {
            this.receiverList = cc.list;
          } else {
            this.receiverList = this.receiverList.concat(cc.list);
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getMoreReceiverList() {
      if (this.loading || this.noMore) return;
      this.receiverParams.pageNum += 1;
      this.getReceiverList();
    },
    filterReceiverList(val) {
      this.receiverParams.pageNum = 1;
      this.receiverParams.condition = val;
      this.getReceiverList();
    },
    setPartyOutput() {
      if (this.loadingBtn || !this.partyCode || !this.receiverId) return;
      const params = {
        pageNum: 1,
        partyCode: this.partyCode,
        receiverId: this.receiverId
      };
      this.loadingBtn = true;
      if (this.sendBtnColor == 'red') {
        this.axios.post('/partyline-backend/kiosk/stopPullStream', params).then(res => {
          this.loadingBtn = false;
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('galleryHost.stopOperationS'));
            this.outputId = '';
            this.receiverId = '';
          }
        }).catch(() => {
          this.loadingBtn = false;
        });
      } else {
        // 在调startPullStream接口之前，检查当前r是否正在Living
        this.checkCurrentRStatus();
      }
    },
    // 检查当前r是否正在Living
    async checkCurrentRStatus() {
      try {
        const {
          data: res
        } = await this.axios.get('/partyline-backend/receiver/getOutputInfo', {
          params: {
            rid: this.receiverId
          }
        });
        let livePeerName = '';
        if (res.result.livePeerName) {
          livePeerName = res.result.livePeerName;
        } else if (res.result.livePeerId) {
          livePeerName = res.result.livePeerId;
        }
        if (res.result.outputStatus) {
          const content = res.result.partyTitle || res.result.partyCode;
          this.tipsInfo.show = true;
          this.tipsInfo.title = 'partyInfo.switchOutput';
          this.tipsInfo.content = `<div class="end">${this.$t('pushParticipantSource.outputContent1')} <span style="color: #28282e;">${content}</span>, ${this.$t('pushParticipantSource.outputContent2')}</div>`;
        } else {
          // 如果在 live 在弹提示
          if (res.result.liveStatus) {
            this.tipsInfo.show = true;
            this.tipsInfo.title = 'pushParticipantSource.switchLive';
            this.tipsInfo.content = `<div class="end">${this.$t('pushParticipantSource.content1')} <span style="color: #28282e;">${livePeerName}</span>, ${this.$t('pushParticipantSource.content2')}</div>`;
          } else {
            this.startPullStream();
          }
        }
      } catch (err) {
        this.loadingBtn = false;
        console.log(err);
      }
    },
    startPullStream() {
      if (!this.partyCode || !this.receiverId) return;
      const params = {
        pageNum: 1,
        partyCode: this.partyCode,
        receiverId: this.receiverId
      };
      this.axios.post('/partyline-backend/kiosk/startPullStream', params, {
        errorTip: false
      }).then(res => {
        this.loadingBtn = false;
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
          this.outputId = this.receiverId;
        } else if (res.data.errorCode == '82203102') {
          this.$message.error(this.$t('common.outputFailed'));
        } else {
          this.$message.error(res.data.errorInfo);
        }
      }).catch(() => {
        this.loadingBtn = false;
      });
    },
    setNameDefault() {
      this.nameCheck = this.nameInfo.checkVal;
    },
    showNamePopup() {
      this.nameInfo.show = true;
      this.nameCheck = this.partyInfo.status.showSlotText;
    },
    setNameOperation() {
      const params = {
        partyCode: this.partyCode,
        module: this.nameCheck ? 'showSlotText' : 'cancelShowSlotText',
        msg: {},
        origin: 'Web_name'
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=74246', params).then(res => {
        const result = res.data;
        if (result.errorCode === '0x0') {
          this.nameInfo.show = false;
          this.partyInfo.status.showSlotText = this.nameCheck;
        }
      });
    }
  }
};